import {
  Actions,
  Box,
  Button,
  Divider,
  IconDocument,
  IconDownload,
  Stack,
  Text,
} from 'braid-design-system';
import { printSchema } from 'graphql';
import { useLocation } from 'react-router';
import { InlineCode, SmartTextLink } from 'scoobie';

import { schema } from '../schema.ts';

import * as styles from './SchemaDefinitionPage.css';

import { BasePage } from '#src/components/BasePage/BasePage.tsx';

const FILENAME = 'seek-api-schema.graphql';

const downloadSchema = (data: string) => {
  const blob = new Blob([data], { type: 'text/csv' });

  const elem = window.document.createElement('a');

  elem.setAttribute('href', window.URL.createObjectURL(blob));

  elem.setAttribute('download', FILENAME);
  elem.style.display = 'none';

  document.body.appendChild(elem);
  elem.click();
  document.body.removeChild(elem);
};

export const SchemaDefinitionPage = () => (
  <BasePage
    breadcrumbs={[
      { href: '/schema', title: 'Schema' },
      { href: useLocation().pathname, title: 'Schema definition' },
    ]}
    icon={<IconDocument />}
    title="Schema definition"
  >
    <Text>
      The SEEK API’s schema expressed in{' '}
      <SmartTextLink href="https://graphql.org/learn/schema/#type-language">
        GraphQL schema definition language
      </SmartTextLink>
      .
    </Text>

    <Text>
      The SEEK API is under continuous development. Make sure to stay up to date
      by subscribing to our{' '}
      <SmartTextLink href="/introduction/release-notes">
        release notes
      </SmartTextLink>
      .
    </Text>

    <Divider />

    <SchemaDefinitionSection />
  </BasePage>
);

export const SchemaDefinitionSection = () => {
  const printed = printSchema(schema);

  return (
    <Stack space="xlarge">
      <Actions>
        <Button icon={<IconDownload />} onClick={() => downloadSchema(printed)}>
          Download
        </Button>
      </Actions>

      <Text>
        <Box className={styles.schemaContainer}>
          <InlineCode weight="weak">{printed}</InlineCode>
        </Box>
      </Text>
    </Stack>
  );
};
